var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.142578,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_23630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 9.14258H24V7.14258H22V9.14258H14V7.14258H12V9.14258H11C9.89 9.14258 9.01 10.0426 9.01 11.1426L9 25.1426C9 26.2426 9.89 27.1426 11 27.1426H25C26.1 27.1426 27 26.2426 27 25.1426V11.1426C27 10.0426 26.1 9.14258 25 9.14258ZM25 25.1426H11V14.1426H25V25.1426ZM13 16.1426H18V21.1426H13V16.1426Z",
    fill: "#797979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_23630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6.14258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevEvent);
export default __webpack_public_path__ + "static/media/prev-event.eeef102a8169624c9398690ad5368500.svg";
export { ForwardRef as ReactComponent };